/* Purpose-driven index — "I want to ___" → suggested Lean tools.
 * Used by the Docs index "Find a tool by purpose" picker.
 */
export const PURPOSES = [
  {
    id: "scope",
    label: "Scope a process / engagement",
    blurb: "Define what is in/out of scope before deeper analysis.",
    tools: ["sipoc_mapper", "voc_kano", "customer_journey", "dmaic_charter"],
  },
  {
    id: "diagnose_waste",
    label: "Diagnose waste & inefficiency",
    blurb: "See where time, motion and capacity are being lost.",
    tools: ["vsm_builder", "waste_walk", "time_study", "spaghetti_diagram", "dilo"],
  },
  {
    id: "find_root_cause",
    label: "Find the root cause of a problem",
    blurb: "Drill from a symptom to its underlying drivers.",
    tools: ["pareto_analyzer", "rca_5whys_fishbone", "pfmea", "a3_problem_solving"],
  },
  {
    id: "size_workforce",
    label: "Size or rebalance a workforce",
    blurb: "Quantify required FTE, line-balance, or call-centre capacity.",
    tools: ["staffing_assessment", "yamazumi", "erlang_c", "monte_carlo_queue", "attrition_cohort"],
  },
  {
    id: "design_solution",
    label: "Design or improve a process",
    blurb: "Build the future-state workflow with the right controls.",
    tools: ["a3_problem_solving", "dmaic_charter", "kaizen_charter", "standard_work", "poka_yoke", "kanban_designer", "smed"],
  },
  {
    id: "prioritise_ideas",
    label: "Prioritise improvement ideas",
    blurb: "Triage a long list against capacity and impact.",
    tools: ["impact_effort", "idea_bank", "automation_scorer"],
  },
  {
    id: "build_business_case",
    label: "Build a business case / ROI",
    blurb: "Quantify benefit, NPV and payback for sponsors.",
    tools: ["roi_calculator", "lean_wave_charter", "benefit_tracker"],
  },
  {
    id: "sustain_change",
    label: "Sustain change & prevent drift",
    blurb: "Embed the operating system that makes gains stick.",
    tools: ["five_s_audit", "kpi_scorecard", "tier_meeting", "leader_standard_work", "lpa_scheduler", "benefit_tracker"],
  },
  {
    id: "grow_capability",
    label: "Grow people & capability",
    blurb: "Build the skills and change-readiness to deliver.",
    tools: ["iluo_matrix", "tna", "adkar", "lean_academy"],
  },
  {
    id: "benchmark_maturity",
    label: "Benchmark maturity / readiness",
    blurb: "Grade an organisation against a Lean reference model.",
    tools: ["maturity_assessment"],
  },
];
